import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { promise } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class CursoUsuarioService {

  public userData:Observable<firebase.User>;

  private coleccionCursos:AngularFirestoreCollection;

  constructor(private afauth:AngularFireAuth, private storage:AngularFireStorage, private db:AngularFirestore) 
  { 
    this.userData = afauth.authState;
    this.coleccionCursos = db.collection("cursos-usuarios");
  }


  verUserData()
  {
    return this.userData;
  }

  guardarUsuarioCurso(curso)
  {
    try {
      this.userData.subscribe(res=>
        {
          const cursoObj = 
          {
            usuario: res.uid,
            curso:curso,
          };
          
          return this.coleccionCursos.add(cursoObj);
  
        })
    } catch (error) {
      return error;
    }
    
    
  }

  subirLink(link, idCurso)
  {
    //traigo el id del curso del REPRODUCIR CURSO

    this.afauth.currentUser.then(res=>
      {

        //console.log("usuario?",res.uid);
        //obtengo ell id del usuario del currentUser
        const usuario = res.uid;

        //recorro todos los curso-usuarios y cuando encuentre el que es lo modifico y le meto el link
        this.getAllUsuarioCurso().subscribe(res=>
          {
            //console.log(res);
            res.forEach(element => {
              if(element.data.usuario == usuario && element.data.curso == idCurso)
              {
                //console.log("deberia entrare 1 vez");
                this.db.collection("cursos-usuarios").doc(element.id).update(
                  {
                    link:link
                  }
                )
                
              }
              
              
            });
          })




       
         })
  }

  //funcion que ve si el usuario compro realmente el curso
  verificarCompra()
  {
    let verificado;

    return new Promise<boolean>((resolve)=>
    {
      this.userData.subscribe(res=>
        {
         // console.log(res.uid);
          let uid = res.uid;

          this.getAllUsuarioCurso().subscribe(res=>
            {
              let usuariosCursos = res;
              usuariosCursos.forEach(element => {
                if(element.data.usuario == uid)
                {
                  verificado = true;
                  resolve(true);
                }
                else{
                  verificado = false;
                }
              });//fin foreach
              resolve(false)
            });//fin del getallusuaruicurso
          
        });//fin del userData
    })
  }
  getAllUsuarioCurso()
  {
    return this.coleccionCursos.snapshotChanges().pipe(
      map(actions=>
       
         actions.map(a=>
           {
             const data = a.payload.doc.data() ;
             const id = a.payload.doc.id;
              return {id, data}; 
           })
           
       )
    )

  }

}
